import { ElementRef, inject, input, NgZone, output, viewChild } from '@angular/core';
import Sortable from 'sortablejs';
import { SecurityListMenuService } from 'SecurityListsApp/ts/services/security-list-menu.service';
import { SkeletonLoadersListModule } from 'Angular/features/components/loaders/skeleton-loaders-list/skeleton-loaders.module';
import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { MultiItemAutocompleteModule } from 'SearchApp/ts/features/multi-item-autocomplete/multi-item-autocomplete.module';
import { disablePointerEvents, enablePointerEvents } from 'Angular/utils/sortable-utils';
import * as i0 from "@angular/core";
import * as i1 from "../modals/help-modal/components/help-modal.component";
import * as i2 from "../../../../../../apps/search/static/search/ts/features/multi-item-autocomplete/components/multi-item-autocomplete.component";
import * as i3 from "../../directives/popovers/tooltip/tooltip.directive";
import * as i4 from "../loaders/skeleton-loaders-list/skeleton-loaders-list.component";
import * as i5 from "../../directives/icon/icon.directive";
const _c0 = ["sortableSecuritiesContainer"];
const _forTrack0 = ($index, $item) => $item.id;
function DraggableSecurityListComponent_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-skeleton-loaders-list", 9);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r2.isLoadingSecurities())("numOfSkeletonLoaders", ctx_r2.securities().length);
} }
function DraggableSecurityListComponent_Conditional_13_For_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "div", 12)(3, "label", 13)(4, "input", 14);
    i0.ɵɵlistener("click", function DraggableSecurityListComponent_Conditional_13_For_1_Template_input_click_4_listener() { const security_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.toggleChartSecurities(security_r5)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 15);
    i0.ɵɵelementStart(6, "span", 16);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 17)(9, "div", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "div", 20);
    i0.ɵɵlistener("click", function DraggableSecurityListComponent_Conditional_13_For_1_Template_div_click_11_listener() { const security_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.removeChartSecurities(security_r5)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(12, "svg", 21);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    let tmp_15_0;
    const security_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-id", security_r5.id);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", security_r5.include);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", (tmp_15_0 = ctx_r2.securitiesInfo()[security_r5.id]) == null ? null : tmp_15_0.security_name, " (", (tmp_15_0 = ctx_r2.securitiesInfo()[security_r5.id]) == null ? null : tmp_15_0.display_security_id, ") ");
} }
function DraggableSecurityListComponent_Conditional_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, DraggableSecurityListComponent_Conditional_13_For_1_Template, 13, 4, "div", 10, _forTrack0);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.securities());
} }
/**
 * Draggable Security List Component
 *
 * Search for securities and display in a list below search bar. Allow to drag and change order of selected items.
 */
export class DraggableSecurityListComponent {
    constructor() {
        this._ngZone = inject(NgZone);
        this._securityListMenuService = inject(SecurityListMenuService);
        this.sortableSecuritiesContainer = viewChild.required('sortableSecuritiesContainer');
        this.securities = input.required(...(ngDevMode ? [{ debugName: "securities" }] : []));
        this.helpModalKey = input('securities', ...(ngDevMode ? [{ debugName: "helpModalKey" }] : []));
        this.searchType = input('main', ...(ngDevMode ? [{ debugName: "searchType" }] : []));
        this.hasSecurityLists = input(false, ...(ngDevMode ? [{ debugName: "hasSecurityLists" }] : []));
        this.isLoadingSecurities = input(false, ...(ngDevMode ? [{ debugName: "isLoadingSecurities" }] : []));
        this.securitiesInfo = input({}, ...(ngDevMode ? [{ debugName: "securitiesInfo" }] : []));
        this.updateOrder = output();
        this.addSecurities = output();
        this.removeSecurity = output();
        this.toggleSecurity = output();
        this.securityListLabels = null;
    }
    ngOnInit() {
        this._securityListMenuService.getLabels().subscribe((response) => {
            this.securityListLabels = response;
        });
    }
    ngAfterViewInit() {
        this.initializeSortable();
    }
    initializeSortable() {
        // For performance reasons we don't want Angular change detection to run while dragging an
        // element around, so we explicitly run SortableJS outside of Angular.
        this._ngZone.runOutsideAngular(() => {
            Sortable.create(this.sortableSecuritiesContainer().nativeElement, {
                handle: '.btn-reorder-up',
                scroll: false,
                animation: 150,
                onUpdate: (event) => {
                    // Once we're done updating we want to emit the output in the zone.
                    this._ngZone.run(() => {
                        const oldIndex = event.oldIndex;
                        const newIndex = event.newIndex;
                        this.updateOrder.emit({
                            oldIndex,
                            newIndex,
                        });
                        // This is a workaround for a bug in the Sortable library which can recheck
                        // unchecked items after dragging. There is no entrypoint provided by SortableJS
                        // after it updates the checkbox state, so we need to delay execution.
                        setTimeout(() => {
                            const { children } = event.target;
                            this.securities().forEach((security) => {
                                for (let i = 0; i < children.length; i += 1) {
                                    const child = children[i];
                                    if (security.id === child.getAttribute('data-id')) {
                                        const el = child.getElementsByClassName('custom-control-input')[0];
                                        if (el.checked !== security.include) {
                                            el.checked = security.include;
                                        }
                                    }
                                }
                            });
                        });
                    });
                },
                onStart: () => {
                    // Prevent pointer-events on btn classes on click in modules-container for tooltip/sortable bug
                    disablePointerEvents(document, 'options-list-item');
                },
                onEnd: () => {
                    enablePointerEvents(document, 'options-list-item');
                },
            });
        });
    }
    toggleChartSecurities(fundChartSecurity) {
        this.toggleSecurity.emit(fundChartSecurity);
    }
    removeChartSecurities(fundChartSecurity) {
        this.removeSecurity.emit(fundChartSecurity);
    }
    addMultipleSecurities(securityIds) {
        this.addSecurities.emit(securityIds);
    }
    addSecurity(securityResult) {
        this.addMultipleSecurities([securityResult.search_id]);
    }
}
DraggableSecurityListComponent.ɵfac = function DraggableSecurityListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DraggableSecurityListComponent)(); };
DraggableSecurityListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DraggableSecurityListComponent, selectors: [["ycn-draggable-security-list"]], viewQuery: function DraggableSecurityListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.sortableSecuritiesContainer, _c0, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
    } }, inputs: { securities: [1, "securities"], helpModalKey: [1, "helpModalKey"], searchType: [1, "searchType"], hasSecurityLists: [1, "hasSecurityLists"], isLoadingSecurities: [1, "isLoadingSecurities"], securitiesInfo: [1, "securitiesInfo"] }, outputs: { updateOrder: "updateOrder", addSecurities: "addSecurities", removeSecurity: "removeSecurity", toggleSecurity: "toggleSecurity" }, decls: 14, vars: 5, consts: [["helpModal", ""], ["sortableSecuritiesContainer", ""], [1, "panel-sidebar-section-header"], [1, "panel-sidebar-section-title", "user-select-none"], [1, "help-toggler", 3, "click"], [1, "panel-sidebar-section-row"], ["data-test-id", "securities-search-autocomplete", 1, "input-group", 3, "multiSubmitHandler", "submitHandler", "appendToBody", "searchType", "showMoreResultsUrl"], [1, "panel-sidebar-section-body"], ["id", "securities-list", 1, "options-list", "user-select-none"], [3, "loading", "numOfSkeletonLoaders"], ["data-test-id", "security-list-item", 1, "options-list-item"], [1, "options-list-item-header"], [1, "options-list-item-title"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "options-list-item-controls"], ["ycnTooltip", "", "tooltipPlacement", "bottom", "tooltipTitle", "Reorder", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-reorder-up"], ["ycnIcon", "", "name", "icon-reorder-up"], ["ycnTooltip", "", "tooltipTitle", "Remove", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", "name", "icon-close"]], template: function DraggableSecurityListComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
        i0.ɵɵtext(2, " Securities ");
        i0.ɵɵelementStart(3, "span", 4);
        i0.ɵɵlistener("click", function DraggableSecurityListComponent_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(6); return i0.ɵɵresetView(helpModal_r2.openModal(ctx.helpModalKey())); });
        i0.ɵɵtext(4, "(?)");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "ycn-help-modal", null, 0);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5)(8, "ycn-multi-item-autocomplete", 6);
        i0.ɵɵlistener("multiSubmitHandler", function DraggableSecurityListComponent_Template_ycn_multi_item_autocomplete_multiSubmitHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addMultipleSecurities($event)); })("submitHandler", function DraggableSecurityListComponent_Template_ycn_multi_item_autocomplete_submitHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addSecurity($event)); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(9, "div", 7)(10, "div", 8, 1);
        i0.ɵɵconditionalCreate(12, DraggableSecurityListComponent_Conditional_12_Template, 1, 2, "ycn-skeleton-loaders-list", 9)(13, DraggableSecurityListComponent_Conditional_13_Template, 2, 0);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵattribute("name", ctx.helpModalKey());
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("appendToBody", true)("searchType", ctx.searchType())("showMoreResultsUrl", false);
        i0.ɵɵadvance(4);
        i0.ɵɵconditional(ctx.isLoadingSecurities() || ctx.hasSecurityLists() && !ctx.securityListLabels ? 12 : 13);
    } }, dependencies: [HelpModalModule, i1.HelpModalComponent, MultiItemAutocompleteModule, i2.MultiItemAutocompleteComponent, TooltipModule, i3.TooltipDirective, SkeletonLoadersListModule, i4.SkeletonLoadersListComponent, IconModule, i5.IconDirective], encapsulation: 2 });
